import axiosInstance from "../../Config/axiosConfig";

export const getBlockedUsers = async () => {
  try {
    const response = await axiosInstance.get('/user/blocked-users');
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};